import { Component } from "react";
import { connect } from "react-redux";
import Base from "../../Layout/Base";
import "./CreateEvents.scss"
import "../../../styles/app/layout/statusbar.scss"
import { getEventsList, publishEvent, setNewEventId, deleteEvent, setEventsListPending, setEventsList, openAddorganizer, closeAddorganizer, openAddEvaluator, closeAddEvaluator } from "../../../store/actions/createEvents.actions";
import { Navigate } from "react-router-dom";
import swal from "sweetalert";
import moment from 'moment-timezone';
import UIModel from "../../Common/UIModal";
import AddOrganizer from "./AddOrganizer";
import AddEvaluator from "./AddEvaluator";

type Props = {
    openCreateEventsList: () => void;
    closeCreateEventsList: () => void;
    getEventsList: () => void;
    setEventsList: () => void;
    isCreateEventsList: boolean;
    eventsList: Event[];
    removeEvent: (id: string, swal: any) => void;
};

const mapStateToProps = (state) => ({
    eventsList: state.createEvent.eventsList,
    isGetEventsPending: state.createEvent.isGetEventsPending,
    profileDetails: state.profile.profileDetails,
    isOpenAddOrganizer: state.createEvent.isOpenAddOrganizer,
    isOpenAddEvaluator: state.createEvent.isOpenAddEvaluator
});
const mapDispatchToProps = (dispatch) => ({
    publishEvent: (id: string) => dispatch(publishEvent(id)),
    getEventsList: () => dispatch(getEventsList()),
    setNewEventId: (id) => dispatch(setNewEventId(id)),
    deleteEvent: (id) => dispatch(deleteEvent(id)),
    setEventsListPending: (data) => (dispatch(setEventsListPending(data))),
    setEventsList: (data) => (dispatch(setEventsList(data))),
    openAddorganizer: () => (dispatch(openAddorganizer())),
    closeAddorganizer: () => (dispatch(closeAddorganizer())),
    openAddEvaluator: () => (dispatch(openAddEvaluator())),
    closeAddEvaluator: () => (dispatch(closeAddEvaluator()))
});

class CreateEvent extends Component<Props, State> {
    state = {
        isCreateNewEvent: false,
        isEditEvent: false,
    };
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: "",
            isCreateNewEvent: false,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount = () => {
        const { getEventsList, setNewEventId, setEventsListPending } = this.props;
        setEventsListPending(false);
        getEventsList();
        setNewEventId(null);
        // this.intervalId = setInterval(getEventsList, 5000);
    };

    componentWillUnmount = () => {
        const{ setEventsList } =this.props;
        setEventsList([]);
    }
    //Interval call
    // componentWillUnmount() {
    //     // Clear the interval when the component is unmounted
    //     clearInterval(this.intervalId);
    //   }

    // CreateEvent = () => {
    //     const { activeScreens } = useUserContext();
    //     const navigate = Navigate();

    //     if (activeScreens.size > 1) {
    //       navigate("/error"); // Redirect if the user is already on another screen
    //     }
    // };

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    handleCreateNewEvent = (e) => {
        e.preventDefault();
        if (window.location.pathname !== "/CreateNewEvent") {
            this.setState({
                isCreateNewEvent: true
            });
        }
    };

    publishEvent = (id) => {
       // const { eventsList } = this.props;
        // let name = "";
        // if (eventsList) {
        //     eventsList.map((data) => {
        //         if (data.id === id) name = data.eventName;
        //         return 0
        //     })
            
        // }
        swal({
            title: "Are you sure?",
           // text: `Do you want to Publish the ${name} event`,
            icon: "info",
            buttons: {
                cancel: true,
                confirm: {
                    text: "Yes, Publish!",
                    value: true,
                    visible: true,
                    className: "bg-ok",
                    closeModal: true,
                },
            },
            closeOnClickOutside: false,
        }).then((value) => {
            const { publishEvent } = this.props
            if (value === true) {
                publishEvent(id);
            }
        });
    };

    handleEditEvent = (id) => {
        const { setNewEventId } = this.props;
        setNewEventId(id);
        this.setState({
            isEditEvent: true
        });
    };

    addOrganiser = (id) => {
        const { setNewEventId, openAddorganizer} = this.props;
        setNewEventId(id);
        openAddorganizer();
    };

    addEvaluator = (id) => {
        const { setNewEventId, openAddEvaluator } = this.props;
        setNewEventId(id);
        openAddEvaluator();
    };

    handleCloseAddOrganizer = () => {
        const { closeAddorganizer } = this.props;
        closeAddorganizer();
    };

    handleCloseAddEvaluator = () => {
        const { closeAddEvaluator } = this.props;
        closeAddEvaluator();
    };

    handleDeleteEvent = (id) => {
        // const { eventsList } = this.props;
        // let name = "";
        // if (eventsList) {
        //     eventsList.map((data) => {
        //         if (data.id === id) name = data.eventName;
        //         return 0;
        //     })
        // }
        swal({
            title: "Are you sure?",
           // text: `Do you want to delete the ${name} event?`,
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: {
                    text: "Yes, delete it!",
                    value: true,
                    visible: true,
                    className: "bg-danger",
                    closeModal: true,
                },
            },
            closeOnClickOutside: false,
        }).then((value) => {
            const { deleteEvent } = this.props;
            if (value === true) {
                deleteEvent(id);
            }
        });
    };

    render() {
        const { searchTerm, isCreateNewEvent, isEditEvent } = this.state;
        const { eventsList, isGetEventsPending, profileDetails, isOpenAddOrganizer, isOpenAddEvaluator } = this.props;

        let content =  null;
        if(isCreateNewEvent || isEditEvent){
            content = <Navigate to={`/CreateNewEvent`} />
        }

        return(
        //  (isCreateNewEvent || isEditEvent) ? (
        //     <Navigate to={`/CreateNewEvent`} />
        // ) :
        //     (
                <Base>
                {content}
                    <div style={{ pointerEvents: isGetEventsPending ? "none" : "all", opacity: isGetEventsPending ? 0.7 : 1, color: isGetEventsPending ? "#000000" : "" }}>
                    <header className="border border-black-500">
                        <div className="statusbar">
                            <h1 className="ml-2 mt-3 mb-3 Statusbartext">
                                Events
                            </h1>
                           {profileDetails && profileDetails.role === "Admin" ? <button className="Statusbarbutton py-2 px-4 mr-4" onClick={(e) => this.handleCreateNewEvent(e)}>
                                <em className="fa fa-plus-circle fa-fw mr-1"></em> Event
                            </button> : ""}
                        </div>
                    </header>
                    {isGetEventsPending ? <div className="dot-spin"></div> : "" }
                    <div className="mr-4 mt-3 mb-3 center-content" style={{ float: "right" }}>
                        <em className="fa fa-search mt-2 mr-2"></em>
                        <input
                            type="string"
                            placeholder="Search Name ..."
                            className="form-control"
                            value={searchTerm}
                            name="searchTerm"
                            onChange={this.handleChange}
                        />
                    </div>
                    {eventsList && eventsList.length > 0 ? (
                        <div style={{ width: "100%", height: "700px", overflow: "auto" }}>
                            <table className="table table-striped table-hover w-100 vw-table" style={{ height: "50px", overflow: "auto" }}>
                                <thead style={{ position: "sticky", top: -1, backgroundColor: "#ffffff",  zIndex: 1 }}>
                                    <tr style={{fontSize:"16px"}}>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            Scheduled Date
                                        </th>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            Event Name
                                        </th>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            Start Date Time
                                        </th>
                                        <th className="text-center" style={{ width: "10%", color: "#00456c" }}>
                                            No.of.Question
                                        </th>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            Evaluation Type
                                        </th>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            Action
                                        </th>
                                        <th className="text-center" style={{ width: "15%", color: "#00456c" }}>
                                            State
                                        </th>
                                    </tr>
                                </thead>
                                <tbody style={{ position: "relative" }}>
                                    {eventsList && eventsList.length > 0 ? eventsList
                                        .filter((data) =>
                                            ((data.eventName||"")).toLowerCase().includes((searchTerm||"").toLowerCase()))
                                        .map((data) => (
                                            <tr key={data.id}>
                                                <td align="center">
                                                    {moment(data.scheduledDate).format('YYYY-MMM-DD')}
                                                </td>
                                                <td align="center">
                                                    {data.eventName}
                                                </td>
                                                <td align="center">
                                                    {moment(data.startDateTime).format('YYYY-MMM-DD hh:mm:ss A')}
                                                </td>
                                                <td align="center">
                                                    {data.noOfQuestions}
                                                </td>
                                                <td align="center">
                                                    {data.evalType ===0 ? "Manual" : "Automatic"}
                                                </td>
                                                <td align="center">
                                                    <div style={{ width: "100%" }} >
                                                        {data.isPublished === true ?
                                                            <div>
                                                                    <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.handleEditEvent(data.id)}>
                                                                        <em className="fa fa-eye mr-4"></em>
                                                                    </button>
                                                                {(profileDetails && profileDetails.role === "Admin") ? <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.addOrganiser(data.id)}>
                                                                        <img className="fa" src="img/Organizer.png" alt="Organizer" height="20px" width="18px"></img>
                                                                    </button> : "" }
                                                                    {((profileDetails && profileDetails.role === "Admin") || (profileDetails && profileDetails.role === "Organizer")) ? <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.addEvaluator(data.id)}>
                                                                        <img className="fa" src="img/Evaluator.png" alt="Evaluator" height="20px" width="17px"></img>
                                                                    </button> : "" }
                                                            </div>
                                                            :
                                                            <div>
                                                                    <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.handleEditEvent(data.id)}>
                                                                        <em className="fa fa-edit mr-4"></em>
                                                                    </button>
                                                                    {(profileDetails && profileDetails.role === "Admin") ? <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.addOrganiser(data.id)}>
                                                                        <img className="fa" src="img/Organizer.png" alt="Organizer" height="20px" width="18px"></img>
                                                                    </button> : "" }
                                                                    {((profileDetails && profileDetails.role === "Admin") || (profileDetails && profileDetails.role === "Organizer")) ? <button className="btn btn-sm btn-secondary mr-2 ml-0" style={{ width: "35px" }} onClick={() => this.addEvaluator(data.id)}>
                                                                        <img className="fa" src="img/Evaluator.png" alt="Evaluator" height="20px" width="17px"></img>
                                                                    </button> : "" }
                                                                    {profileDetails && profileDetails.role === "Admin" ?
                                                                    <button className="btn btn-sm btn-secondary ml-0" style={{ width: "35px" }} onClick={() => this.handleDeleteEvent(data.id)}>
                                                                        <em className="fa fa-trash mr-4"></em>
                                                                    </button>: "" }

                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                                <td align="center">
                                                    {data.isPublished === true ?
                                                        <span>

                                                            <button disabled="true" className="Action-button mt-1" style={{ cursor: "not-allowed", opacity: "0.9" }}>
                                                                Published
                                                            </button>
                                                        </span>
                                                        :
                                                        <span>

                                                            <button className="Action-button-publish mt-1" onClick={() => this.publishEvent(data.id)}>
                                                                Publish
                                                            </button>
                                                        </span>}
                                                </td>
                                            </tr>
                                        )) : ""}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="mt-4" style={{ textAlign: "center" }}>No Events, click + Event to create one</p>
                    )}
                </div>
                <UIModel header="MAP ORGANIZER"
                    isOpen={isOpenAddOrganizer}
                    handleClose={this.handleCloseAddOrganizer}
                >
                    <AddOrganizer
                        handleClose={this.handleCloseAddOrganizer}
                        modalSize="large"
                    /></UIModel>
                    <UIModel header="MAP EVALUATOR"
                    isOpen={isOpenAddEvaluator}
                    handleClose={this.handleCloseAddEvaluator}
                >
                    <AddEvaluator
                        handleClose={this.handleCloseAddEvaluator}
                        modalSize="large"
                    /></UIModel>
                </Base>
                
            )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateEvent);